import { Controller } from '@hotwired/stimulus'

// Handles the schoolyear new form: toggling category sections on/off.
// When a category checkbox is unchecked, all hour_bank input fields for that
// category are disabled and hidden so they are not submitted with the form.
export default class extends Controller {
  static targets = ['categoryToggle', 'categorySection']

  connect() {
    // On page load (including re-renders after a failed submit), sync the
    // disabled/hidden state of each category section to its checkbox state.
    this.categoryToggleTargets.forEach((checkbox) => {
      this._applyState(checkbox.dataset.categoryId, checkbox.checked)
    })
  }

  toggleCategory(event) {
    const checkbox = event.target

    this._applyState(checkbox.dataset.categoryId, checkbox.checked)
  }

  _applyState(categoryId, enabled) {
    this.categorySectionTargets
      .filter((section) => section.dataset.categoryId === categoryId)
      .forEach((section) => {
        section.style.display = enabled ? '' : 'none'
        section.querySelectorAll('input').forEach((input) => {
          input.disabled = !enabled
        })
      })
  }
}
